import type { Apprentice } from "../models/apprentice";
import type { NamedUser } from "../models/user";
import type { YearContext } from "../models/yearContext";

export function getFullName<T extends NamedUser>(user: T | undefined): string {
  return user ? `${user.first_name} ${user.last_name}` : "-";
}

export function getFullNameWithGroup(apprentice: Apprentice | undefined): string {
  const groupName = apprentice?.group ? `(${apprentice?.group.name})` : "";

  return `${getFullName(apprentice)} ${groupName}`;
}

export function getYearString(yearContext?: YearContext) {
  if (!yearContext) {
    return "-";
  }
  return `${yearContext.starts_at}/${yearContext.ends_at}`;
}

export function getShortYearString(yearContext?: YearContext) {
  if (!yearContext) {
    return "-";
  }
  return `${lastTwoDigits(yearContext.starts_at)}/${lastTwoDigits(yearContext.ends_at)}`;
}

const lastTwoDigits = (num: number) => Math.abs(num % 100);
